import { devError } from '@/utils/devLog';
/** TOTP côté client (connexion 2FA) — import dynamique otpauth */
export async function verifyTOTPClient(secret: string, code: string): Promise<boolean> {
  try {
    const { TOTP } = await import('otpauth');
    const totp = new TOTP({
      issuer: 'eServices',
      label: 'Account',
      algorithm: 'SHA1',
      digits: 6,
      period: 30,
      secret,
    });
    const delta = totp.validate({ token: code, window: 1 });
    return delta !== null;
  } catch (error) {
    devError('TOTP verification error', error);
    return false;
  }
}

export function generateRecoveryCodes(): string[] {
  const codes: string[] = [];
  for (let i = 0; i < 10; i++) {
    const part1 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const part2 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const part3 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const part4 = Math.random().toString(36).substring(2, 6).toUpperCase();
    codes.push(`${part1}-${part2}-${part3}-${part4}`);
  }
  return codes;
}

export function hashRecoveryCode(code: string): string {
  return btoa(code);
}
